<template>
  <div class="roma-page-content fill-height bg-white">
    
    <FilterLesson />
    <div class="d-flex justify-content-center pt-5" v-if="loading">
        <v-progress-circular indeterminate color="#743085"></v-progress-circular>
        <v-progress-circular class="mx-2" indeterminate color="#E67F24"></v-progress-circular>
        <v-progress-circular class="mr-2" indeterminate color="#389CC3"></v-progress-circular>
        <v-progress-circular indeterminate color="#FADF2C"></v-progress-circular>
    </div>
    <template v-if="!loading && this.lessons && this.lessons.content && this.lessons.content.length">
      <LessonsList :items="lessons" />
    </template>

    <template v-if="!loading && this.lessons && this.lessons.content && this.lessons.content.length == 0">
      <div class="px-3">
        <v-row>
            <v-col cols="12" class="d-flex align-items-center info-box parrafo-2">
          <v-icon color="#D8D7D9" class="mr-2">mdi-information-outline</v-icon>  No se han encontrado clases
        </v-col>
        </v-row>
      </div>
    </template>
    

  </div>
</template>

<script>
import FilterLesson from "@/components/lesson/RomaFilterLesson.vue";
import LessonsList from "@/components/lesson/RomaLessonsList.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    sidebarExpanded: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      buttonOptions: {
        title: "Nueva Clase",
        icon: "mdi-plus",
        color: "accent",
      },
    };
  },
  components: {
    FilterLesson,
    LessonsList,
  },
  async mounted() {
    this.setLayout("main-layout");
    this.actionGetLessons({ pageNumber: 0, pageSize: 8, sectionId: this.user.section.sectionId });
    this.actionGetProgress({ sectionId: this.user.section.sectionId });
    await this.actionGetInformationLesson(this.getInstitutionId);
    console.log(this.lessons.content.length);
    console.log(this.getInstitutionId);
  },
  computed: {
    ...mapGetters({
      layout: "getLayout",
      lessons: "getLessons",
      user: "getUserData",
      getInstitutionId: "getInstitutionId",
      loading: "getLoading"
    }),
  },
  methods: {
    ...mapActions({
      setLayout: "setLayout",
      toastSuccess: "toastSuccess",
      toastError: "toastError",
      actionGetLessons: "actionGetLessons",
      actionGetProgress: "actionGetProgress",
      actionGetInformationLesson: "actionGetInformationLesson"
    }),
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/generals";
.back {
  background-image: url("../../assets/images/Ilustracion No tiene Clases.svg");
  background-repeat: no-repeat;
  background-size: 50% 50%;
  background-position: center 60%;
  height: 100%;
}

.title {
  position: relative;
  top: 70px;
  color: rgb(236, 139, 49);
}

</style>
